import React from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setPostalRewards } from '@/features/shippingDetails/shippingDetailsSlice';
import paymentTextContent from '@/features/paymentSelect/paymentTextContent';
import CheckboxWithSvg from '@/components/common/CheckboxWithSvg';
import {
  PostalRewardsBoldText,
  PostalRewardsSmallText
} from './PostalRewardsCheckbox.style';

export default function PostalRewardsCheckbox() {
  const { aarnPostalRewardsBoldText, aarnPostalRewardsSmallText } = paymentTextContent;
  const dispatch = useAppDispatch();
  const shippingDetailsState = useAppSelector(state => state.shippingDetails);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setPostalRewards(event.target.checked));
  };

  return (
    <CheckboxWithSvg
      checked={shippingDetailsState.postalRewards}
      htmlFor="postalRewards"
      dataTest="postalRewardsContentWrapper"
      svgFilePath="/assets/images/teddy-bear.svg"
      onChange={handleChange}
      hiddenCheckboxId="postalRewards"
    >
      <PostalRewardsBoldText checked={shippingDetailsState.postalRewards}>
        {aarnPostalRewardsBoldText}
      </PostalRewardsBoldText>
      <PostalRewardsSmallText checked={shippingDetailsState.postalRewards}>
        {aarnPostalRewardsSmallText}
      </PostalRewardsSmallText>
    </CheckboxWithSvg>
  );
}
